import React from 'react';

export interface Props {
  className?: string;
  ticks: any[];
  scale: any;
}

class VerticalAxis extends React.Component<Props, any> {
  public render() {
    const { className, scale, ticks } = this.props;

    return (
      <g className={`${className} vertical-axis`}>
        {ticks.map((tick, i) => (
          <text
            key={`tick-${i}`}
            className="tick"
            textAnchor="middle"
            dy="0.35em"
            y={scale(tick)}
          >
            {tick}
          </text>
        ))}
      </g>
    );
  }
}

export default VerticalAxis;
